<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addTermsOfDelivery></addTermsOfDelivery>
    </v-dialog>

</template>

<script>
    import {TermsOfDeliverySettings} from '../../../store/namespace-helper'

    import addTermsOfDelivery from '../../Shared/AddTermsOfDelivery.vue'

    export default {
      name: 'add-new-terms-of-delivery-dialog',
      components: {
        addTermsOfDelivery
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[TermsOfDeliverySettings.getters.getOpenNewDialogState]
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Settings/TermsOfDelivery/AddTermsOfDeliveryDialog.vue